import React from "react";
import moment from "moment";
import {Route, Switch, useHistory, useLocation, useParams, useRouteMatch} from "react-router-dom";
import {IoMdArrowBack} from "react-icons/io"
import Blocks from "../blocks";
import addQuestion from "../../assets/images/addQuestion.png";
import {getClassById} from "../../api/virtualClass";

const tabList = ["My PlayList", "External Content", "Internal Content"];

const PageAddingQuestion = () => {
    const history = useHistory();
    const params = useParams();
    const location = useLocation();
    const classPlanID = location?.state?.classPlanID;
    const {path, url} = useRouteMatch();
    const classId = params.classId;
    
    const {status, data, error, isFetching} = getClassById(classId);
    const _classData = data?.data;


    const title = "Adding content";
    let backURL = url.split("/");
    backURL.pop();
    backURL = backURL.concat("class-plan").join("/");
    const goToClassPlan = () => {
        const id = localStorage.getItem('classPlanID'); //get the class plan ID from the localstorage
        history.push(`${backURL}/${id}`);
    }
    return (
        <div className={"page PageAddingContent oveflow-y-auto"}>
            <div className="container mx-auto">
                <div className="flex lg:hidden items-center pt-16 pb-4 pl-4">
                    <IoMdArrowBack onClick={() => goToClassPlan()} size={20}
                                   className="mr-3 cursor-pointer"/>
                    <h3
                        className={
                            "text-xl text-center  font-['Poppins-Bold']"
                        }
                    >
                        {title}
                    </h3>
                </div>
                <ul
                    className={
                        "flex lg:hidden flex-wrap items-center justify-center gap-2 md:gap-8 mb-6 md:mb-14 text-sm"
                    }
                >
                    <li className={"flex items-center"}>
                        <p>Subject - {_classData?.subject?.title}</p>
                    </li>
                    <li className={"flex items-center"}>
                        <p>Class - {_classData?.title}</p>
                    </li>
                    <li className={"flex items-center"}>
                        <p>Date - 12th Jan 2022</p>
                    </li>
                    <li className={"flex items-center"}>
                        <span className="icon icon-clock text-gray-500 mr-2 text-lg"></span>
                        <p>
                            Time-{moment.unix(_classData?.start_time).format("HH:mmA")}-
                            {moment
                                .unix(_classData?.start_time + _classData?.duration_seconds)
                                .format("HH:mmA")}
                        </p>
                    </li>
                </ul>
                <div className="flex flex-col lg:flex-row items-center">
                    <div className="bgWrapper lg:flex justify-center items-center bg-white">
                        <img src={addQuestion} alt="" draggable={false}/>
                    </div>
                    <div
                        className="pageContent w-full max-w-2xl h-screen90 mx-auto md:mr-0 md:ml-auto  mb-4 bg-white p-4 rounded-xl">
                        <div className="hidden lg:flex items-center mb-4 ">
                            <IoMdArrowBack onClick={() => goToClassPlan()} size={30}
                                           className="mr-3 cursor-pointer"/>
                            <h1 className={" text-4xl font-heading"}>
                                {title}
                            </h1>
                        </div>
                        <Blocks.ErrorBoundary>
                            <ul
                                className={
                                    "hidden lg:flex flex-col md:flex-row gap-4 md:gap-8 mb-6 md:mb-5 text-lg"
                                }
                            >
                                <li className={"flex items-center gap-2"}>
                                    <i className="icon icon-book-open"></i>
                                    <p>{_classData?.subject?.title}</p>
                                </li>
                                <li className={"flex items-center gap-2"}>
                                    <i className="icon icon-git-commit"></i>
                                    <p>{_classData?.title}</p>
                                </li>
                                <li className={"flex items-center gap-2"}>
                                    <i className="icon icon-calendar"></i>
                                    <p>{moment(_classData?.createdOn).format("MM.DD.YYYY")}</p>
                                </li>
                                <li className={"flex items-center gap-2"}>
                                    <i className="icon icon-clock"></i>
                                    <p>
                                        {moment(_classData?.start_time + _classData?.duration_seconds)
                                            .format("HH:mmA")}-
                                        {moment(_classData?.end_time + _classData?.duration_seconds)
                                            .format("HH:mmA")}
                                    </p>
                                </li>
                            </ul>

                            <div
                                id="contentWrapperBox"
                                className="rounded-xl bg-neutral-100 p-4 flex flex-col flex-auto justify-between h-full contentWrapper relative"
                            >
                                <div className="flex-auto flex flex-col">
                                    <div className="flex flex-auto flex-col">
                                        <Switch>
                                            <Route path={`${path}/playlists`} component={Blocks.BlockPlaylists}/>
                                            <Route path={`${path}/playlist`}
                                                   component={Blocks.BlockPlaylistDetail}/>
                                            <Route path={`${path}/topic/:id`} component={Blocks.BlockTopicDetail}/>
                                            <Route path={`${path}/select-content/:id`}
                                                   component={Blocks.BlockAddPlayListContent}/>
                                            <Route path={`${path}/add-boolean-question/:id`}
                                                   component={Blocks.BlockAddBooleanQuestion}/>
                                            <Route path={`${path}/question`}
                                                   component={Blocks.BlockAddQuestion}/>
                                            <Route path={`${path}/question-list`} component={Blocks.BlockQuestionList}/>
                                            <Route path={`${path}/`} component={Blocks.BlockAddQuestionLandingScreen}/>
                                        </Switch>
                                    </div>
                                </div>

                            </div>
                        </Blocks.ErrorBoundary>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageAddingQuestion;
